export default {

    SET_WHATCHIMP_AUTH(state, payload) {
        state.whatChimpAuth = payload
        state.conectado     = payload != null
    },

    SET_WHATCHIMP_CONNECTING(state, value) {
        state.whatChimpConnecting = value
    },

    SET_WHATCHIMP_ERROR(state, payload) {
        state.whatChimpError = payload
    },

    SET_WHATCHIMP_TEMPLATES(state, templates) {
    state.whatsappTemplates = templates
    },

    SET_WHATCHIMP_VARIABLES(state, variables) {
        state.whatsappVariables = variables
    },  

}


// WEBPACK FOOTER //
// ./src/modules/whatChimpApi/mutations.js